var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 14.8262V13.4928C14.6673 12.2503 13.8175 11.2062 12.6673 10.9102M10.334 3.02001C11.3113 3.4156 12.0007 4.37371 12.0007 5.49284C12.0007 6.61196 11.3113 7.57007 10.334 7.96567M11.334 14.8262C11.334 13.5837 11.334 12.9624 11.131 12.4723C10.8603 11.8189 10.3412 11.2998 9.68781 11.0292C9.19775 10.8262 8.5765 10.8262 7.33398 10.8262H5.33398C4.09147 10.8262 3.47022 10.8262 2.98016 11.0292C2.32675 11.2998 1.80762 11.8189 1.53697 12.4723C1.33398 12.9624 1.33398 13.5837 1.33398 14.8262M9.00065 5.49284C9.00065 6.9656 7.80674 8.15951 6.33398 8.15951C4.86122 8.15951 3.66732 6.9656 3.66732 5.49284C3.66732 4.02008 4.86122 2.82617 6.33398 2.82617C7.80674 2.82617 9.00065 4.02008 9.00065 5.49284Z",
    stroke: "#8B38FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubIcon);
export default __webpack_public_path__ + "static/media/hub-icon.1e6fd96a5173c8aa9f9b4bc29983fce3.svg";
export { ForwardRef as ReactComponent };